import * as React from "react";
import { cn } from "@/lib/utils";

const PillButton = React.forwardRef(
  ({ active = false, className, children, onClick, ...props }, ref) => (
    <button
      ref={ref}
      type="button"
      onClick={onClick}
      className={cn(
        "flex-1 h-11 rounded-[8px] border text-[14px] font-semibold transition-all duration-200 ease-smooth",
        active
          ? "bg-accent-pink text-[#091424] border-accent-pink shadow-sm"
          : "bg-bg-primary text-text-secondary border-border-default hover:border-accent-pink/60 hover:text-white",
        className
      )}
      {...props}
    >
      {children}
    </button>
  )
);
PillButton.displayName = "PillButton";

export { PillButton };
export default PillButton;
